import { cn } from "../lib/utils"
import { Button } from "./ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "./ui/card"

const GoogleIcon = () => (
  <svg width="16" height="16" viewBox="0 0 18 18" fill="none">
    <path d="M17.64 9.2045c0-.638-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9086C16.6582 14.2527 17.64 11.945 17.64 9.2045z" fill="#4285F4"/>
    <path d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9086-2.2581c-.8055.54-1.8364.8591-3.0477.8591-2.3446 0-4.3286-1.5832-5.0368-3.7105H.9574v2.3318C2.4382 15.9832 5.4818 18 9 18z" fill="#34A853"/>
    <path d="M3.9632 10.71c-.18-.54-.2823-1.1168-.2823-1.71s.1023-1.17.2823-1.71V4.9582H.9574C.3477 6.1732 0 7.5477 0 9s.3477 2.8268.9574 4.0418L3.9632 10.71z" fill="#FBBC05"/>
    <path d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.4259 0 9 0 5.4818 0 2.4382 2.0168.9574 4.9582L3.9632 7.29C4.6714 5.1627 6.6554 3.5795 9 3.5795z" fill="#EA4335"/>
  </svg>
)

export function LoginForm({ className, onGoogleLogin, signingIn, onSwitchToSignup, ...props }) {
  return (
    <div className={cn("flex flex-col gap-6", className)} {...props}>
      <Card className="border-[var(--border-ui)] bg-[var(--surface)] card-inset-sm">
        <CardHeader className="pb-4">
          <CardTitle className="text-xl font-bold tracking-tight text-[var(--text)]">Welcome back</CardTitle>
          <CardDescription className="text-[var(--muted-text)]">
            Sign in to your account
          </CardDescription>
        </CardHeader>
        <CardContent className="pt-0">
          <Button
            variant="outline"
            type="button"
            className="w-full border-[var(--border-ui)] bg-[var(--soft-fill)] text-[var(--text)] hover:bg-[var(--soft-fill)] hover:text-[var(--text)]"
            onClick={onGoogleLogin}
            disabled={signingIn}
          >
            {signingIn ? (
              <svg className="animate-spin w-4 h-4" viewBox="0 0 24 24" fill="none">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8h4z"/>
              </svg>
            ) : <GoogleIcon />}
            {signingIn ? "Signing in…" : "Continue with Google"}
          </Button>
          <p className="mt-4 text-center text-sm text-[var(--subtle-text)]">
            Don&apos;t have an account?{" "}
            <button
              type="button"
              onClick={onSwitchToSignup}
              className="text-[var(--text-soft)] underline underline-offset-4 hover:text-[var(--text)]"
            >
              Sign up
            </button>
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
